<template>
  <div class="layout-box">
    <LayoutHeader headtitle="行业图谱"></LayoutHeader>
    <div class="secondary-content">
      <GoBack></GoBack>
      <div class="experts-title">
        <div class="bread-crumb-nav">当前位置：<a href="/">首页</a> > <a @click="$router.go(-1)">行业图谱</a> > {{names}}<span class="titp">点击放大查看</span></div>
      </div>
      <div class="new-detail">
        <div class="new-detail-content">
          <viewer :images='[mapdatas]'>
            <img :src='mapdatas' :alt="names+'图'" />
          </viewer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/layout-header2";
import GoBack from "../layout/layout-goback";

export default {
  name: 'IndustryMapD',
  components:{
    LayoutHeader,
    GoBack
  },
  data () {
    return {
      mapdatas:'',
      names:''
    }
  },
  mounted () {
    let imgname=localStorage.getItem('mapdata')
    this.mapdatas=require('../../assets/img/'+imgname+'.png')
    this.names=localStorage.getItem('mapdataname')
  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: calc(100% - 170px);
  padding-top: 170px;
  background: url("../../assets/erj_bj.fw.png");
}

.secondary-content{
  width: 1100px;
  height: 100%;
  margin: 0 auto;
  position: relative;
  background: #0A47B6;
}


.new-detail{
  padding: 30px 48px;
  width: calc(100% - 96px);
  height: calc(100% - 60px);
}

.experts-title{
  width:100%;
  height: 59px;
  background-image: linear-gradient(rgba(239,243,254,.2),rgba(197,210,250,.48));
}

.bread-crumb-nav{
  font-size: 16px;
  color: #fff;
  font-family: 微软雅黑;
  line-height: 59px;
  padding-left: 20px;
}

.bread-crumb-nav a{
  cursor: pointer;
  color: #fff;
  text-decoration: none;
}
.bread-crumb-nav a:hover{
  text-decoration: underline;
  font-weight: bold;
}

.new-detail-content{
  width: 100%;
  font-size: 16px;
  color: #fff;
  line-height: 217%;
  overflow: auto;
  height: calc(100% - 50px);
  background: #FFFFFF;
}

.new-detail-content::-webkit-scrollbar{
  display: none;
}

.new-detail-content img{
  width: 100%;
  display: inline-block;
  margin: 10px auto;
}

.titp{
  float: right;
  margin-right: 12px;
  height: 30px;
  line-height: 30px;
  margin-top: 14px;
  font-size: 12px;
  padding: 0 12px;
  background: rgba(20,65,199,.9);
  border-radius: 18px;
}


</style>



// WEBPACK FOOTER //
// src/views/secondary/secondary-industrymap-details.vue